var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectStoreLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#60B0F9",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.6766,
    stroke: "url(#paint0_linear_24180_20859)",
    strokeOpacity: 0.3,
    strokeWidth: 0.646875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19922 11.2986C7.19922 8.70108 9.36988 6.60156 11.9955 6.60156C14.6286 6.60156 16.7992 8.70108 16.7992 11.2986C16.7992 12.6076 16.3232 13.8228 15.5396 14.8528C14.6752 15.989 13.6098 16.9789 12.4106 17.7559C12.1362 17.9354 11.8885 17.949 11.5872 17.7559C10.3812 16.9789 9.31579 15.989 8.4588 14.8528C7.67469 13.8228 7.19922 12.6076 7.19922 11.2986ZM10.4153 11.4762C10.4153 12.3464 11.1253 13.0308 11.996 13.0308C12.8672 13.0308 13.5841 12.3464 13.5841 11.4762C13.5841 10.6128 12.8672 9.89504 11.996 9.89504C11.1253 9.89504 10.4153 10.6128 10.4153 11.4762Z",
    fill: "#8DC8FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24180_20859",
    x1: -6.3,
    y1: -35.4,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectStoreLocationIcon);
export default __webpack_public_path__ + "static/media/SelectStoreLocationIcon.1d55f4c9249a6c2b4dc5fa68cc565690.svg";
export { ForwardRef as ReactComponent };